import type { ReactNode } from 'react';

export enum Platform {
  Instagram = 'Instagram',
  YouTubeShorts = 'YouTubeShorts',
  TikTok = 'TikTok',
  Facebook = 'Facebook',
  Twitter = 'Twitter',
  Threads = 'Threads',
}

export interface Video {
  id: string;
  title: string;
  thumbnailUrl: string;
  views: string;
  uploadedAt: string;
  creatorName: string;
  platform: Platform;
  notes?: string;
}

export interface Creator {
  id: string;
  name: string;
  handle: string;
  avatarUrl:string;
  platform: Platform;
  isLive?: boolean;
  videos: Video[];
}

export interface AnalyticsData {
    views: TimeDataPoint[];
    engagement: PlatformDataPoint[];
    performance: PerformanceDataPoint[];
}

export interface TimeDataPoint {
    name: string;
    views: number;
}

export interface PlatformDataPoint {
    name: Platform;
    engagement: number;
}

export interface PerformanceDataPoint {
    name: Platform;
    performance: number;
}

export interface NavItem {
  href: string;
  labelKey: string;
  icon: ReactNode;
  activeIcon?: ReactNode;
}